import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-5c2db4d2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "contest-table-container"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  class: "pt3"
};
var _hoisted_4 = /*#__PURE__*/_createTextVNode("模拟赛");
var _hoisted_5 = /*#__PURE__*/_createTextVNode("正式赛");
var _hoisted_6 = /*#__PURE__*/_createTextVNode("查看");
var _hoisted_7 = /*#__PURE__*/_createTextVNode("去答辩");
var _hoisted_8 = /*#__PURE__*/_createTextVNode("答题入口（去答题）");
var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 考试准备 ");
var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 试卷 ");
var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 下载准考证 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_tag = _resolveComponent("a-tag");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_space = _resolveComponent("a-space");
  var _component_a_table = _resolveComponent("a-table");
  var _component_ExamInfoModal = _resolveComponent("ExamInfoModal");
  var _component_ExamTicket = _resolveComponent("ExamTicket");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
    dataSource: _ctx.list,
    columns: _ctx.columns,
    rowKey: function (record) {
      return record.userExamId;
    },
    pagination: _ctx.pagination,
    scroll: {
      x: true
    },
    onChange: _ctx.onPaginationChange,
    rowClassName: function (record) {
      return _ctx.getRowClassName(record);
    }
  }, {
    contestInfo: _withCtx(function (_a) {
      var record = _a.record;
      return [_createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("a", {
        href: "javascript:;",
        onClick: function ($event) {
          return _ctx.goToItemDetail(record);
        }
      }, _toDisplayString(record.contestInfoName), 9, _hoisted_2)]), _createElementVNode("div", null, [_createVNode(_component_a_tag, {
        class: "item-name-text"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(record.contestItemName), 1)];
        }),
        _: 2
      }, 1024)]), _createElementVNode("div", _hoisted_3, [+record.examType === 1 ? (_openBlock(), _createBlock(_component_a_tag, {
        key: 0,
        color: "#cecece"
      }, {
        default: _withCtx(function () {
          return [_hoisted_4];
        }),
        _: 1
      })) : (_openBlock(), _createBlock(_component_a_tag, {
        key: 1,
        color: "#ff6a00"
      }, {
        default: _withCtx(function () {
          return [_hoisted_5];
        }),
        _: 1
      }))])])];
    }),
    startTime: _withCtx(function (_a) {
      var record = _a.record;
      return [_createElementVNode("div", null, _toDisplayString(_ctx.formatDateToSecond(record.startTime)), 1)];
    }),
    endTime: _withCtx(function (_a) {
      var record = _a.record;
      return [_createElementVNode("div", null, _toDisplayString(_ctx.formatDateToSecond(record.endTime)), 1)];
    }),
    totalScore: _withCtx(function (_a) {
      var record = _a.record;
      return [_createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(record.scoreDesc || (record.totalScore === null ? '--' : record.totalScore)), 1)])];
    }),
    passed: _withCtx(function (_a) {
      var record = _a.record;
      return [_createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(record.passDesc ? record.passDess : _ctx.value2label(record.passed, _ctx.USER_EXAM_PASSED, '--')), 1)])];
    }),
    awarded: _withCtx(function (_a) {
      var record = _a.record;
      return [_createElementVNode("div", null, [_createElementVNode("div", null, _toDisplayString(record.awardDesc ? record.awardDesc : _ctx.value2label(record.awarded, _ctx.USER_EXAM_AWARDED, '--')), 1)])];
    }),
    operation: _withCtx(function (_a) {
      var record = _a.record;
      return [_createVNode(_component_a_space, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_button, {
            type: "default",
            shape: "round",
            onClick: function ($event) {
              return _ctx.checkDetail(record);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 2
          }, 1032, ["onClick"]), record.status === 1 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            shape: "round",
            onClick: function ($event) {
              return _ctx.showExamInfo(record);
            }
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.getBtnText(record)), 1)];
            }),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), record.status === 2 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "primary",
            shape: "round",
            onClick: function ($event) {
              return _ctx.goToExamAnswer(record);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), record.status === 3 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 2,
            type: "primary",
            shape: "round",
            disabled: ""
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          })) : _createCommentVNode("", true), record.status === 4 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 3,
            type: "primary",
            shape: "round",
            onClick: function ($event) {
              return _ctx.goCheckDevice(record);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_9];
            }),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), record.showPaper === 1 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 4,
            type: "primary",
            shape: "round",
            onClick: function ($event) {
              return _ctx.goToAnswerPaper(record);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)];
        }),
        _: 2
      }, 1024), record.examMode && record.examType === 0 ? (_openBlock(), _createBlock(_component_a_space, {
        key: 0,
        class: "pt3"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_button, {
            type: "primary",
            shape: "round",
            onClick: function ($event) {
              return _ctx.getExamTicket(record);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 2
      }, 1024)) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["dataSource", "columns", "rowKey", "pagination", "onChange", "rowClassName"]), _createVNode(_component_ExamInfoModal, {
    data: _ctx.examInfo
  }, null, 8, ["data"]), _createVNode(_component_ExamTicket, {
    data: _ctx.ExamTicketData
  }, null, 8, ["data"])]);
}